import React from 'react';
import { PageBanner } from '../components/PageBanner';
import { FAQSection } from '../components/FAQSection';
import { ContactCTA } from '../components/ContactCTA';
export function FAQPage() {
  return <main data-id="element-648">
      <PageBanner title="Frequently Asked Questions" subtitle="Find answers to common questions about our home healthcare services." breadcrumbs={[{
      label: 'FAQs',
      path: '/faq'
    }]} data-id="element-649" />
      <FAQSection data-id="element-650" />
      <ContactCTA data-id="element-651" />
    </main>;
}